import ScalarIconPencilSimple_vue_vue_type_script_setup_true_lang_default from "./ScalarIconPencilSimple.vue.script.js";
//#region src/components/ScalarIconPencilSimple.vue
var ScalarIconPencilSimple_default = ScalarIconPencilSimple_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconPencilSimple_default as default };

//# sourceMappingURL=ScalarIconPencilSimple.js.map